import SpeciesActions from './Actions'

export const getColumns = (rowId, setRowId) => [
  { field: 'id', headerName: 'ID', headerAlign: 'center', width: 70 },
  {
    field: 'nombre',
    headerName: 'Nombre',
    headerAlign: 'center',
    flex: 2,
    minWidth: 150,
    editable: true,
  },
  {
    field: 'habilitado',
    headerAlign: 'center',
    headerName: 'Habilitado',
    type: 'boolean',
    flex: 2,
    minWidth: 150,
    editable: true,
  },
  {
    field: 'actions',
    headerAlign: 'center',
    headerName: 'Acciones',
    type: 'actions',
    renderCell: params => <SpeciesActions {...{ params, rowId, setRowId }} />,
    minWidth: 100,
    flex: 1.2,
  },
]
